export default __webpack_public_path__ + "static/media/gaobaiqiqiu.8058b5a4.svga";